export enum IncidentSubTypes {
  None = 0,
  General = 1,
  Near_Miss = 2,
  Medical = 3,
  Job = 4,
}
